module.exports = __webpack_public_path__ + "static/media/default.4d682f85.PNG";